import BookingForm from "../booking-form/booking-form";

function App() {
  return (
    <div className="wrapper">
      <BookingForm/>
    </div>
  );
}

export default App;
